import { render, staticRenderFns } from "./addBusiness.vue?vue&type=template&id=1947d66e"
import script from "./addBusiness.vue?vue&type=script&lang=js"
export * from "./addBusiness.vue?vue&type=script&lang=js"
import style0 from "./addBusiness.vue?vue&type=style&index=0&id=1947d66e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports